module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="suite" id="'+
((__t=( suite.suite.id ))==null?'':__t)+
'">\n\t<div class="suite-title fn-show-setup">\n\t\t<h1 class="suite-title-text">'+
((__t=( suite.suite.name ))==null?'':__t)+
'</h1>\n\t\t<span class="suite-controls">\n\t\t\t<a href="#" class="fn-run-suite">'+
((__t=( dictionary.runSuite ))==null?'':__t)+
'</a>\n\t\t</span>\n\t</div>\n\t<div class="suite-setup hidden">\n\t\t';

		var code = '';
		if (suite.originOption) {
			code += hilite('// options\n');
			code += hilite(JSON.stringify(suite.originOption, null, 2));
		}
		if (suite.setupFn) {
			if (code) {
				code += '\n\n';
			}
		  code += hilite('// suite preparation code (deprecated)\n');
		  code += hilite(fnstrip(suite.setupFn));
		}
		if (suite.beforeSuiteListeners.callbacks.length) {
			if (code) {
				code += '\n\n';
			}
			code += hilite('// suite preparation code');
			suite.beforeSuiteListeners.callbacks.forEach(function (callback) {
				code +=  '\n' + hilite(fnstrip(callback));
			});
		}
		if (suite.beforeBenchListeners.callbacks.length) {
			if (code) {
				code += '\n\n';
			}
			code += hilite('// benchmark preparation code');
			suite.beforeBenchListeners.callbacks.forEach(function (callback) {
				code += '\n' + hilite(fnstrip(callback));
			});
		}
		if (!(suite.setupFn || suite.beforeSuiteListeners.callbacks.length ||
					suite.beforeBenchListeners.callbacks.length)) {
			if (code) {
				code += '\n\n';
			}
			code += hilite('// no preparation code');
		}
		
__p+='\n\t\t';
 if (code) { 
__p+='\n\t\t<pre><code>'+
((__t=( code ))==null?'':__t)+
'</code></pre>\n\t\t';
 } 
__p+='\n\t</div>\n\t<div class="fn-benchs suite-bench-list"></div>\n</div>';
}
return __p;
};
